<template>
	<div class="page">
		<div class="editionHeart" >
			<compCrumbs></compCrumbs>
		</div>
		<div class="editionHeart">
			<div class="addrLine">
				<div class="titleBox">
					<div class="titleName">确认收货地址</div>
					<div class="titleR" @click="clickAddAddr">新增地址</div>
				</div>
				<div class="addrBox" :class="opened?'addrOpened':''">
					<div class="addrItem" v-for="(item,index) in addrList" :key="index" :class="curAddr._id===item._id?'active':''" @click="changeCurAddr(item)">
						<div class="addrUserName">
							{{item.province_name}}{{item.city_name}}{{item.district_name}}（{{item.user_name}}收）
						</div>
						<div class="addrText">
							{{item.address}}
							{{item.phone}}
						</div>
					</div>
				</div>
				<div class="openCloseLine" v-if="addrList.length>4">
					<div class="open" v-if="opened" @click="opened=false">折叠<img style="width:20px;vertical-align: text-top;margin-left:10px;" src="../../../assets/img/order/addrClose.png"/></div>
					<div class="open" v-else @click="opened=true">展开<img style="width:20px;vertical-align: text-top;margin-left:10px;" src="../../../assets/img/order/addrOpen.png"/></div>
				</div>
			</div>
			<div class="goodsLine">
				<div class="titleBox">
					<div class="titleName">确认订单信息</div>
					<div class="titleR"></div>
				</div>
				<div class="goodsMsg">
					<div class="rowTitle">
						<div class="rowTitleCell" style="width:200px;">商品图片</div>
						<div class="rowTitleCell" style="width:300px;">商品信息</div>
						<div class="rowTitleCell" style="width:150px;">单价</div>
						<div class="rowTitleCell" style="width:150px;">数量</div>
						<div class="rowTitleCell" style="width:250px;">优惠方式</div>
						<div class="rowTitleCell" style="width:150px;">小计</div>
					</div>
					<div class="rowBody">
						<div class="rowBodyCell" style="width:200px;">
							<div class="cellBox">
								<img :src="petDetail.cover" style="width: 110px;height: 110px;"/>
							</div>
						</div>
						<div class="rowBodyCell" style="width:300px;">
							<div class="cellBox">
								<div>宠物昵称：{{petDetail.petName}}</div>
								<div>宠物ID：{{petDetail.epromNo}}</div>
								<div>年龄：{{petDetail.age}}</div>
								<div v-if="!$public.isNull(petDetail.petSex)">性别：{{petDetail.petSex==='公'?'弟弟':'妹妹'}}</div>
							</div>
						</div>
						<div class="rowBodyCell" style="width:150px;">
							<div class="cellBox">
								<div>¥{{petDetail.price}}</div>
							</div>
						</div>
						<div class="rowBodyCell" style="width:150px;">
							<div class="cellBox">
								<div>1</div>
							</div>
						</div>
						<div class="rowBodyCell" style="width:250px;">
							<div class="cellBox">
								<div></div>
							</div>
						</div>
						<div class="rowBodyCell" style="width:150px;">
							<div class="cellBox">
								<div>¥{{petDetail.price}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="serviceLine">
				<div class="titleBox">
					<div class="titleName">花生宠物保障服务</div>
					<div class="titleR"></div>
				</div>
				<div class="serviceBox">
					<!-- <img class="serviceImg" v-if="curService===30" src="../../../assets/img/order/service30Checked.png"/>
					<img class="serviceImg" v-else @click="curService=30" src="../../../assets/img/order/service30.png"/>
					<img class="serviceImg" v-if="curService===100" src="../../../assets/img/order/service100Checked.png"/>
					<img class="serviceImg" v-else @click="curService=100" src="../../../assets/img/order/service100.png"/> -->
					<img class="serviceImg" v-if="curService===30" src="../../../assets/img/order/service30Checked.png"/>
					<img class="serviceImg" v-if="curService===100" src="../../../assets/img/order/service100Checked.png"/>
				</div>
			</div>
			<div class="remarkLine">
				<el-input type="textarea" v-model="remark" :rows="5" placeholder="请输入订单备注，选填"></el-input>
			</div>
			<div class="moneyLine">
				<div class="moneyBox">
					<span class="moneyLabel">快递配送</span>
					<span class="moneyNum">￥{{logistics}}</span>
				</div>
				<div class="moneyBox">
					<span class="moneyLabel">订单合计（含运费）</span>
					<span class="moneyNum">¥{{$public.jia(petDetail.price,logistics)}}</span>
				</div>
			</div>
			<div class="payLine">
				<div class="agreeBox">
					<img class="agreeImg" v-if="agreeState" @click="agreeState=!agreeState" src="../../../assets/img/order/payChecked.png"/>
					<img class="agreeImg" v-else @click="agreeState=!agreeState" src="../../../assets/img/order/payNoChecked.png"/>
					我已阅读并同意<span style="color:#6362FB;" @click="toH5('gcxy')">《购宠协议》</span>
				</div>
				<div class="payBtnBox">
					<span class="payBtnLabel">支付方式</span>
					<img class="payBtnImg" v-if="curPayMethod===1" src="../../../assets/img/order/weixinChecked.png"/>
					<img class="payBtnImg" v-else @click="curPayMethod=1" src="../../../assets/img/order/weixin.png"/>
					<img class="payBtnImg" v-if="curPayMethod===2" src="../../../assets/img/order/zhifubaoChecked.png"/>
					<img class="payBtnImg" v-else @click="curPayMethod=2" src="../../../assets/img/order/zhifubao.png"/>
				</div>
				<div class="payMoney">
					实付款：￥<span style="font-size: 32px;color:#2A2B39;">{{$public.jia(petDetail.price,logistics)}}</span>
				</div>
				<div class="payAddr" v-if="curAddr._id">
					寄送至：
					<span style="display: inline-block;text-align: left;vertical-align: text-top;">
						{{curAddr.province_name}} {{curAddr.city_name}} {{curAddr.district_name}} {{curAddr.address}}
					</span>
				</div>
				<div class="payAddr" v-if="curAddr._id">
					收货人：<span>{{curAddr.user_name}} {{curAddr.phone}}</span>
				</div>
				<div class="paySubmit">
					<div class="paySubmitBtn" @click="submitOrder">扫码支付</div>
				</div>
			</div>
		</div>
		<div v-if="dialogAddShipAddress_state">
			<dialogAddShipAddress @submit="submit_dialogAddShipAddress"></dialogAddShipAddress>
		</div>
		<!-- 登录 -->
		<div v-if="dialogLogin_state">
			<dialogLogin @submit="submit_dialogLogin"></dialogLogin>
		</div>
		<div v-if="dialogQRCode_state">
			<dialogQRCode :QRCode="wexinPay" :orderNum="orderNum" @submit="submit_dialogQRCode"></dialogQRCode>
		</div>
		<div v-html="alipay" ref="alipayDiv" style="width:0;height: 0;overflow: hidden;"></div>
	</div>
</template>

<script>
	import dialogAddShipAddress from "../../my/shipAddress/dialog_addShipAddress.vue"
	import compCrumbs from "../../../components/compCrumbs.vue"
	import dialogLogin from "../../frame/dialog_login.vue"
	import dialogQRCode from "../../../components/dialogQRCode.vue"
	export default {
		components:{dialogAddShipAddress,compCrumbs,dialogLogin,dialogQRCode},
		data() {
			return {
				curAddr:{},
				addrList:[],
				opened:false,
				
				petDetail:{},
				
				logistics:0, // 运费
				
				curService:30,
				curPayMethod:1,
				remark:'',
				
				// 新增收货地址
				dialogAddShipAddress_state:false,
				// 支付
				dialogQRCode_state:false,
				wexinPay:'',
				orderNum:'', // 订单编号
				alipay:'',
				// 购宠协议
				agreeState:false,
				// 登录
				dialogLogin_state:false,
			}
		},
		computed:{
			userInfo(){
				return this.$store.state.userInfo;
			}
		},
		mounted(){
			let dayValue = this.$route.query.dayValue
			if(!this.$public.isNull(dayValue)){
				if(dayValue==='day100'){
					this.curService = 100
				}else if(dayValue==='day30'){
					this.curService = 30
				}
			}
			
			this.getPetDetail()
		},
		methods:{
			toH5(str){
				if(str==='gcxy'){
					if(this.isZZ()){
						window.open('https://www.huashengchongwu.com/xieyi/appH5/gouchongbaitianyiliao.html')
					}else{
						window.open('https://www.huashengchongwu.com/xieyi/appH5/gouchong30tianhuanchong.html')
					}
				}
			},
			// 登录
			submit_dialogLogin(obj){
				this.dialogLogin_state = false;
				if(obj.type==='success'){
					this.getPetDetail()
				}
			},
			// 新增收货地址
			clickAddAddr(){
				if(this.$public.isNull(this.userInfo)){
					this.dialogLogin_state = true;
				}else{
					this.dialogAddShipAddress_state=true;
				}
			},
			submit_dialogAddShipAddress(obj){
				this.dialogAddShipAddress_state = false;
				if(obj.type==='success'){
					this.getAddressList()
				}
			},
			// 切换收货地址
			changeCurAddr(item){
				this.curAddr=item;
				this.getLogistics()
			},
			// 提交订单
			submitOrder(){
				if(this.$public.isNull(this.userInfo)){
					this.dialogLogin_state = true;
					return ;
				}
				if(this.$public.isNull(this.curAddr._id)){
					this.$message({
						type: 'error',
						message: '请选择收货地址'
					});
					return 
				}
				if(this.agreeState===false){
					this.$message({
						type: 'error',
						message: '请阅读并同意购宠协议'
					});
					return 
				}
				let safeguard_type = null;
				if(this.curService===30){
					safeguard_type={id:'1', name:'30天无理由退换货'}
				}else if(this.curService===100){
					safeguard_type={id:'2', name:'100天宠物医疗保障'}
				}
				let params = {
					"postage": this.logistics,  // 邮费
					"remark": this.remark,  // 
					"address": this.curAddr.address,  // 收货地址
					"ship_adddress": {
						"province_name": this.curAddr.province_name,  // 省
						"city_name": this.curAddr.city_name,  // 市
						"district_name": this.curAddr.district_name,  // 区
						"address": this.curAddr.address,  // 详细地址
						"zip_code":this.curAddr.zip_code,  // 邮编
						"user_name": this.curAddr.user_name,  // 收货人名称
						"phone": this.curAddr.phone,  // 手机号
					},
					"province": this.curAddr.province_name,  // 省
					"city": this.curAddr.city_name,  // 市
					"total_price": this.$public.jia(this.petDetail.price,this.logistics),  // 订单金额
					"pet_id": this.petDetail.petId,  // 宠物id
					"pet_tag": [],  // 宠物标签
					"activity_id": "",  // 活动id
					"coupon_no": "",  // 优惠券
					"distribution_type": 0,  // 配送方式 1 快递 2 上门自提
					"distribution_shop": {
						"company_id": "5e9412e0b2bfbc030160bdd5",  // 隶属公司id
						"company_name": "河南花生宠物医院有限公司",  // 隶属公司名称
						"shop_id": "5e9412e0b2bfbc089daerr11",  // 隶属门店id
						"shop_name": "官网活体商城",  //隶属门店名称
					},
					"reserved_phone": this.curAddr.phone,  // 预留手机号
					"safeguard_type": safeguard_type,
					"order_plate": null,
					"invitation_code": this.$store.state.inviteCode||'',  // 邀请用户信息
				}
				let loading = this.$loading()
				this.$http.post(process.env.VUE_APP_livingMall+'/api/Order/CreatePetOrder', params).then(res => {
					loading.close()
					if(res.code===0){
						let loading1 = this.$loading()
						this.$http.post(process.env.VUE_APP_livingMall+'/api/Order/OrderPay', {
							"order_no": res.data,
							"money": this.$public.jia(this.petDetail.price,this.logistics),
							"yue_money": 0,
							"type": this.curPayMethod,
							"openid": "",
						}).then(res1 => {
							loading1.close()
							if(res1.code===0){
								if(this.curPayMethod===1){
									this.wexinPay = res1.data
									this.orderNum = res.data;
									this.$nextTick(()=>{
										this.dialogQRCode_state=true
									})
								}else if(this.curPayMethod===2){
									this.alipay = res1.data.substr(0,res1.data.length-57)
									this.$nextTick(()=>{
										this.$refs.alipayDiv.children[0].submit()
									})
								}
							}
						})
					}
				})
			},
			// 微信支付完成
			submit_dialogQRCode(obj){
				this.wexinPay='';
				this.orderNum="";
				this.dialogQRCode_state=false
				if(obj.type==='success'){
					this.$router.replace({path:'/order/livingOrderResult',query:{no:obj.data.orderNum,type:'payResult'}})
				}
			},
			getPetDetail(){
				let params = {
					id:this.$route.query.id
				}
				let loading = this.$loading()
				this.$http.get(process.env.VUE_APP_livingMall+'/api/Pet/detail/info', params).then(res => {
					loading.close()
					if(res.code===0){
						this.petDetail = res.data
					}
					this.getAddressList()
				})
			},
			getAddressList(){
				if(this.$public.isNull(this.userInfo)){
					return ;
				}
				let params = {}
				let loading = this.$loading()
				this.$http.get(process.env.VUE_APP_livingMall+'/api/ShipAddress/list', params).then(res => {
					loading.close()
					if(res.code===0){
						this.addrList = res.data
						let addrValue = this.$route.query.addrValue
						if(!this.$public.isNull(addrValue)){
							for(let i=0;i<this.addrList.length;i++){
								if(this.addrList[i]._id===addrValue){
									this.curAddr=this.addrList[i]
									this.getLogistics()
									return ;
								}
							}
						}else{
							for(let i=0;i<this.addrList.length;i++){
								if(this.addrList[i].is_default===1){
									this.curAddr=this.addrList[i]
									this.getLogistics()
									return ;
								}
							}
						}
						
					}
				})
			},
			getLogistics(){
				let params = {
					"orderType": "1",  // 订单类型 o:商品订单 1:活体订单
					"province": this.curAddr.province_name,
					"city": this.curAddr.city_name,
					"orderAmount": this.petDetail.price,  // 订单金额
				}
				let loading = this.$loading()
				this.$http.post(process.env.VUE_APP_livingMall+'/api/Logistics/calc/Freight', params).then(res => {
					loading.close()
					if(res.code===0){
						if(res.data.support===0){
							this.$message({
								type: 'error',
								message: res.data.info
							});
							this.logistics = 0
						}else{
							this.logistics = res.data.amount
						}
						this.isZZ()
					}
				})
			},
			isZZ(){
				if(this.$public.isNull(this.curAddr._id)){
					this.curService=30
				}else{
					let str = this.curAddr.province_name+this.curAddr.city_name+this.curAddr.district_name+this.curAddr.address;
					if(str.indexOf("郑州")>0){
						this.curService=100;
					}else{
						this.curService=30;
					}
				}
			},
		},
	}
</script>

<style lang="scss" scoped>
.page{
	.addrLine{
		padding-top:0px;
		.titleBox{
			display: flex;justify-content: space-between;
			.titleName{
				font-size: 22px;color:#303042;font-weight: bold;line-height: 40px;
			}
			.titleR{
				width:140px;height: 40px;border:1px solid #C6A0FF;background-color: #F4EFFF;line-height: 38px;font-size: 18px;color:#7C29F1;text-align: center;cursor: pointer;
			}
		}
		.addrBox{
			display: flex;flex-wrap: wrap;padding-top: 25px;height: 130px;overflow: hidden;
			&.addrOpened{
				height: auto;
			}
			.addrItem{
				width:290px;background-color: #F6F6F8;padding:20px;box-sizing: border-box;margin:0 5px;cursor: pointer;margin-bottom:10px;
				&.active{
					background: url(../../../assets/img/order/addrBg.png) no-repeat;background-size: 100% 100%;
				}
				.addrUserName{
					font-size: 18px;color:#303042;font-weight: bold;
				}
				.addrText{
					font-size: 16px;color:#303042;padding-top:22px;line-height: 20px;
				}
			}
		}
		.openCloseLine{
			padding:10px 0;
			.open{
				text-align: center;cursor: pointer;
			}
		}
	}
	.goodsLine{
		padding-top:50px;
		.titleBox{
			display: flex;justify-content: space-between;
			.titleName{
				font-size: 22px;color:#303042;font-weight: bold;line-height: 40px;
			}
			.titleR{ }
		}
		.goodsMsg{
			.rowTitle{
				background-color: #F6F6F8;display: flex;margin-top: 20px;
				.rowTitleCell{
					line-height: 64px;font-size: 18px;color:#303042;padding-left:20px;box-sizing: border-box;
				}
			}
			.rowBody{
				display: flex;
				.rowBodyCell{
					padding-left:20px;box-sizing: border-box;padding: 20px;
					.cellBox{
						font-size: 16px;color:#303042;line-height: 25px;
					}
				}
			}
		}
	}
	.serviceLine{
		padding-top:50px;
		.titleBox{
			display: flex;justify-content: space-between;
			.titleName{
				font-size: 22px;color:#303042;font-weight: bold;line-height: 40px;
			}
			.titleR{ }
		}
		.serviceBox{
			padding:20px 0;
			.serviceImg{
				width:192px;height: 102px;margin:0 10px;cursor: pointer;
			}
		}
	}
	.remarkLine{
		padding-top:30px;
	}
	.moneyLine{
		text-align: right;padding-top:30px;
		.moneyBox{
			font-size: 16px;padding-top:10px;
			.moneyLabel{
				color:#303042;width:150px;display: inline-block;text-align: left;
			}
			.moneyNum{
				color:#FF1800;width:80px;display: inline-block;
			}
		}
	}
	.payLine{
		text-align: right;padding:20px 0 60px;border-top: 1px solid #E8E8EB;margin-top: 20px;
		.agreeBox{
			padding:30px 0;
			.agreeImg{
				vertical-align: text-bottom;width:20px;height: 20px;
			}
		}
		.payBtnBox{
			.payBtnLabel{
				font-size: 22px;color:#303042;line-height: 80px;margin-right: 30px;
			}
			.payBtnImg{
				width:240px;height: 80px;margin-left:10px;vertical-align: middle;cursor: pointer;
			}
		}
		.payMoney{
			font-size: 16px;color:#303042;padding-top:30px;
		}
		.payAddr{
			font-size: 16px;color:#303042;padding-top:30px;line-height: 20px;
		}
		.paySubmit{
			display: flex;justify-content: flex-end;margin-top:30px;
			.paySubmitBtn{
				background-color: #35353B;color:#fff;text-align: center;width:240px;line-height: 100px;font-size: 22px;cursor: pointer;
			}
		}
	}
}
</style>							
